export const THEME_COLORS = {
    INTRO: 'blue.400',
    REMINDERS: 'green.400',
    STATEMENT: 'orange.300',
    RESOLUTION_STEPS: 'purple.500',
    CONCLUSION: 'red.400'
}